import { render } from "./codesList.vue?vue&type=template&id=67c77ba9&scoped=true"
import script from "./codesList.vue?vue&type=script&lang=js"
export * from "./codesList.vue?vue&type=script&lang=js"

import "./codesList.vue?vue&type=style&index=0&id=67c77ba9&lang=scss&scoped=true"

import exportComponent from "E:\\wwwroot\\qifu-web-v1.0.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c77ba9"]])

export default __exports__